var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.678,
    height: 24.675,
    viewBox: "0 0 24.678 24.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-key-677345",
    transform: "translate(-72.857 -16.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3550",
    "data-name": "Path 3550",
    d: "M98.126,33.413l1.16,1.16a1.312,1.312,0,0,0,.976.4h1.373v1.16h0a1.575,1.575,0,0,0,1.575,1.575h1.16v1.37h0a1.386,1.386,0,0,0,.4.966l.911.911h0a1.286,1.286,0,0,0,.908.373H110.2a1.131,1.131,0,0,0,1.129-1.128V36.586a1.283,1.283,0,0,0-.378-.913l-7.542-7.542a8.623,8.623,0,1,0-5.283,5.283ZM90.293,20.292a7.046,7.046,0,0,1,11.473,7.728.788.788,0,0,0,.168.863l7.817,7.82v3.052H106.7l-.769-.769V37.132a1.013,1.013,0,0,0-1.013-1.013H103.21v-1.7A1.013,1.013,0,0,0,102.2,33.4h-1.853L98.88,31.938a.788.788,0,0,0-.863-.168A7.046,7.046,0,0,1,90.29,20.3Zm3.3,6.191a2.886,2.886,0,1,0-2.041-.846A2.886,2.886,0,0,0,93.589,26.483Zm0-4.178a1.308,1.308,0,1,1-.929.383,1.312,1.312,0,0,1,.929-.383Z",
    transform: "translate(-13.794 0)",
    fill: "#f37320"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.9e76374c3a196c304db9952a956d179e.svg";
export { ForwardRef as ReactComponent };